export default __webpack_public_path__ + "static/media/trophy.1f0b320c.svg";